import styles from "../../../styles/Participant-Employment.module.css"
import { groupBy, groupTable, getStartAndEndTime } from "../Utils/Utils"
import ViewHeader from "../Utils/ViewHeader"

const JobRecordView = ({ jobRecord, closeForm, loading, viewMode }) => {
  const jobRecordDic = [
    {
      label: "Engagement date",
      value: jobRecord?.engagementDate,
      type: "date",
      group: 1,
    },
    {
      label: "Engagement channel",
      value: jobRecord?.engagementChannelStr,
      type: "string",
      group: 1,
    },
    {
      label: "Start time",
      value: getStartAndEndTime(jobRecord?.startTime, jobRecord?.endTime),
      type: "html",
      group: 1,
    },
    {
      label: "First day of employment",
      value: jobRecord?.firstEmploymentDay,
      type: "date",
      group: 2,
    },
    {
      label: "Job title",
      value: jobRecord?.jobTitle,
      type: "string",
      group: 2,
    },
    {
      label: "Duties",
      value: jobRecord?.duties,
      type: "html",
      group: 3,
    },
    {
      label: "Rate of pay",
      value: jobRecord?.rateOfPay,
      type: "string",
      group: 4,
    },
    {
      label: "Pay",
      value: jobRecord?.pay === 0 ? "" : jobRecord?.pay,
      type: "string",
      group: 4,
    },
    {
      label: "Benefits",
      value: jobRecord?.benefits,
      type: "html",
      group: 5,
    },
    {
      label: "Is this a job union position?",
      value: jobRecord?.isUnionPositionStr,
      type: "string",
      group: 6,
    },
    {
      label: "Disclosure to contact employer",
      value: jobRecord?.disclosureToContactEmployerStr,
      type: "string",
      group: 6,
    },
    {
      label: "Work schedule",
      value: jobRecord?.workSchedule,
      type: "html",
      group: 7,
    },
  ]
  const employerDic = [
    {
      label: "Name",
      value: jobRecord?.employerName,
      type: "string",
      group: 1,
    },
    {
      label: "Country",
      value: jobRecord?.employerCountry,
      type: "string",
      group: 2,
    },
    {
      label: "State",
      value: jobRecord?.employerState,
      type: "string",
      group: 2,
    },
    {
      label: "City",
      value: jobRecord?.employerCity,
      type: "string",
      group: 2,
    },
    {
      label: "Zip code",
      value: jobRecord?.employerZipCode,
      type: "string",
      group: 2,
    },
    {
      label: "Street address",
      value: `${jobRecord?.employerAddressOne} ${jobRecord?.employerAddressTwo}`,
      type: "string",
      group: 3,
    },
  ]
  const supervisorDic = [
    {
      label: "Name",
      value: jobRecord?.supervisorName,
      type: "string",
      group: 1,
    },
    {
      label: "Email",
      value: jobRecord?.supervisorEmail,
      type: "string",
      group: 2,
    },
    {
      label: "Phone",
      value: jobRecord?.supervisorPhone,
      type: "string",
      group: 2,
    },
  ]

  const basicInfo = groupBy(jobRecordDic, "group")
  const employerInfo = groupBy(employerDic, "group")
  const supervisorInfo = groupBy(supervisorDic, "group")

  return (
    <div className={styles.rounded_wrapper}>
      <ViewHeader
        viewMode={viewMode}
        closeViewMode={closeForm}
        title={"Job record"}
      />
      {groupTable(basicInfo)}
      {groupTable(employerInfo, "Employer")}
      {groupTable(supervisorInfo, "Supervisor")}
    </div>
  )
}
export default JobRecordView
